import { Activity, ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'

import { DeltaText, Pulse } from '@/components/activity/activity-panel'
import { RoutePaths } from '@/routes/routes'
import { useQueryGetPlatformActivity } from '@/services'
import { formatNumber } from '@/utils/activity'

/** compact DAU · WAU · MAU strip linking to the Platform activity page */
export const PlatformActivityStrip = () => {
  const { data, isLoading, isError } = useQueryGetPlatformActivity({
    org_limit: 1
  })

  if (isError) return null

  const summary = data?.summary
  const metrics = summary
    ? ([
        ['DAU', summary.dau, summary.dau_prev],
        ['WAU', summary.wau, summary.wau_prev],
        ['MAU', summary.mau, summary.mau_prev]
      ] as const)
    : []

  return (
    <Link
      aria-label="Open platform activity"
      className="mb-4 flex flex-wrap items-center gap-x-6 gap-y-2 rounded-lg bg-muted/30 px-4 py-2.5 text-sm text-foreground transition-colors hover:bg-muted/40"
      to={RoutePaths.INTERNAL_BI}
    >
      <span className="inline-flex items-center gap-2 font-medium">
        <Activity className="h-4 w-4 text-secondary" />
        Platform activity
      </span>
      {isLoading ? (
        <Pulse className="h-4 w-72" />
      ) : (
        <>
          {metrics.map(([label, value, prev]) => (
            <span className="inline-flex items-baseline gap-1.5" key={label}>
              <span className="text-xs text-muted-foreground/70">{label}</span>
              <span className="font-semibold tabular-nums">
                {formatNumber(value)}
              </span>
              <DeltaText className="text-xs" current={value} previous={prev} />
            </span>
          ))}
          {summary && (
            <span className="inline-flex items-center gap-1.5">
              <span className="h-2 w-2 rounded-full bg-emerald-400" />
              <span className="font-semibold tabular-nums">
                {formatNumber(summary.active_now)}
              </span>
              <span className="text-xs text-muted-foreground/70">
                active now
              </span>
            </span>
          )}
        </>
      )}
      <ChevronRight className="ml-auto h-4 w-4 text-muted-foreground/60" />
    </Link>
  )
}
